export default "__VITE_ASSET__DL1JV4eO__"